import { useState } from 'react';
import { AppointmentResponseDto } from '../../../../types/appointment.types';
import { appointmentService } from '../../../../services/appointment.service';
import { toastService } from '../../../../services/toast.service';
import { getErrorMessage } from '../../../../utils/api-response.util';

export function useClientAppointmentActions(onSuccess: () => void) {
  const [selected, setSelected] = useState<AppointmentResponseDto | null>(null);
  const [modalLoading, setModalLoading] = useState(false);

  const [cancelTarget, setCancelTarget] = useState<AppointmentResponseDto | null>(null);
  const [cancelling, setCancelling] = useState(false);

  const [confirming, setConfirming] = useState(false);

  const [rescheduleTarget, setRescheduleTarget] = useState<AppointmentResponseDto | null>(null);
  const [reviewTarget, setReviewTarget] = useState<AppointmentResponseDto | null>(null);

  const handleOpenDetails = async (id: number) => {
    setSelected(null);
    setModalLoading(true);
    try {
      const details = await appointmentService.getAppointmentDetails(id);
      setSelected(details);
    } catch {
      toastService.error('Не вдалося завантажити деталі запису.');
    } finally {
      setModalLoading(false);
    }
  };

  const handleCloseDetails = () => {
    setSelected(null);
    setModalLoading(false);
  };

  const handleCancel = async (reason: string) => {
    if (!cancelTarget) return;
    setCancelling(true);
    try {
      await appointmentService.cancelAppointment(cancelTarget.id, { cancellationReason: reason });
      toastService.success('Запис скасовано.');
      if (selected?.id === cancelTarget.id) handleCloseDetails();
      setCancelTarget(null);
      onSuccess();
    } catch (e) {
      toastService.error(getErrorMessage(e, 'Не вдалося скасувати запис.'));
    } finally {
      setCancelling(false);
    }
  };

  const handleConfirm = async (appointmentId: number) => {
    setConfirming(true);
    try {
      await appointmentService.confirmAppointment(appointmentId);
      toastService.success('Запис підтверджено.');
      if (selected?.id === appointmentId) handleCloseDetails();
      onSuccess();
    } catch (e) {
      toastService.error(getErrorMessage(e, 'Не вдалося підтвердити запис.'));
    } finally {
      setConfirming(false);
    }
  };

  return {
    selected,
    modalLoading,
    handleOpenDetails,
    handleCloseDetails,
    cancelTarget,
    cancelOpen: cancelTarget !== null,
    openCancelDialog: setCancelTarget,
    closeCancelDialog: () => setCancelTarget(null),
    handleCancel,
    cancelling,
    handleConfirm,
    confirming,
    rescheduleTarget,
    openRescheduleDialog: setRescheduleTarget,
    closeRescheduleDialog: () => setRescheduleTarget(null),
    reviewTarget,
    openReviewDialog: setReviewTarget,
    closeReviewDialog: () => setReviewTarget(null),
  };
}
